import pdpCustomPersonalization from '../pdp/rbmc.pdp-custom-personalization';
import pdpBlacklist from '../pdp/rbmc.pdp-blacklist';
import productDetails from './rbmc.pdp';

const pdpFlockingWFL = {
    wflFlockFormWrapper: undefined,
    wflFlockForm:        undefined,
    wflInput:            undefined,
    resetButton:         undefined,
    wflDeliveryMessage:  undefined,
    inputIsValid:        false,
    inputLocked:         false,
    wflValidationRegex:  new RegExp("^[A-Z0-9ÄÖÜß?'\/@#!.,()\" =+|*; \-]*$"),

    init() {
        pdpFlockingWFL.wflFlockFormWrapper = $('.pdp__wfl-flock');
        pdpFlockingWFL.wflFlockForm        = $('#plp__wfl-flock-form');
        pdpFlockingWFL.wflInput            = pdpFlockingWFL.wflFlockFormWrapper.find('#pdp__wfl-flock-input');
        pdpFlockingWFL.wflLock             = pdpFlockingWFL.wflFlockFormWrapper.find('.pdp__wfl-flock-lock');
        pdpFlockingWFL.labelForErrors      = pdpFlockingWFL.wflFlockFormWrapper.find('.custom-form__label--invalid');
        pdpFlockingWFL.resetButton         = pdpFlockingWFL.wflFlockForm.find('.pdp__icon-reset');
        pdpFlockingWFL.wflDeliveryMessage  = $('.pdp_wfl-delivery-wrapper');
        pdpFlockingWFL.bindEvents();
    },

    bindEvents() {
        pdpFlockingWFL.wflInput.on('change input blur', pdpFlockingWFL.validateFlockString);
        pdpFlockingWFL.wflLock.on('click', pdpFlockingWFL.lockPersonalizedChoice);
        pdpFlockingWFL.resetButton.on('click', pdpFlockingWFL.resetWflForm);
    },

    validateFlockString() {
        const errorMessage   = pdpFlockingWFL.wflFlockForm.find('.message-error'),
              warningMessage = pdpFlockingWFL.wflFlockForm.find('.message-warning');

        warningMessage.addClass('d-none');

        //transform uppercase as user types
        pdpFlockingWFL.wflInput.val(pdpCustomPersonalization.formatCustomName(
                pdpFlockingWFL.wflInput.val()
        ));

        //validate cases
        const wflInput = pdpFlockingWFL.wflInput.val();
        if (!pdpFlockingWFL.wflValidationRegex.test(wflInput) || wflInput.length > 40 || pdpBlacklist.isBlacklisted(wflInput)) {
            pdpFlockingWFL.wflFlockForm.addClass('custom-form--invalid');
            pdpFlockingWFL.inputIsValid = false;
            errorMessage.removeClass('d-none');
        } else {
            pdpFlockingWFL.wflFlockForm.removeClass('custom-form--invalid');
            pdpFlockingWFL.inputIsValid = true;
            errorMessage.addClass('d-none');
        }
    },

    lockPersonalizedChoice() {
        pdpFlockingWFL.validateBeforeSubmit();
        if (pdpFlockingWFL.inputIsValid) {
            pdpFlockingWFL.wflLock.addClass('disabled').prop('disabled', true);
            pdpFlockingWFL.wflLock.find('.pdp__wfl-locked').removeClass('d-none');
            pdpFlockingWFL.wflLock.find('.pdp__wfl-unconfirmed').addClass('d-none');
            pdpFlockingWFL.resetButton.removeClass('d-none');
            pdpFlockingWFL.wflDeliveryMessage.removeClass('d-none');
            pdpFlockingWFL.wflInput.prop('readonly', true);
            pdpFlockingWFL.inputLocked                                    = true;
        }
    },

    validateBeforeSubmit() {
        const warningMessage = pdpFlockingWFL.wflFlockForm.find('.message-warning');
        if (pdpFlockingWFL.wflInput.val() === '') {
            pdpFlockingWFL.inputIsValid = false;
            pdpFlockingWFL.wflFlockForm.addClass('custom-form--invalid');
            warningMessage.removeClass('d-none');
            return false;
        }
        warningMessage.addClass('d-none');
        return true;
    },

    resetWflForm(evt) {
        evt.stopImmediatePropagation();
        pdpFlockingWFL.wflLock.removeClass('disabled').prop('disabled', false);
        pdpFlockingWFL.wflLock.find('.pdp__wfl-locked').addClass('d-none');
        pdpFlockingWFL.wflLock.find('.pdp__wfl-unconfirmed').removeClass('d-none');
        pdpFlockingWFL.resetButton.addClass('d-none');
        pdpFlockingWFL.wflInput.prop('readonly', false).val('');
        pdpFlockingWFL.wflDeliveryMessage.addClass('d-none');
        pdpFlockingWFL.inputIsValid                                   = false;
        pdpFlockingWFL.inputLocked                                    = false;
    }
};

export default pdpFlockingWFL;
